import View from "./View";

const Comparison = ({ project }) => <View project={project} />;

export default Comparison;
